import { createMemoStyles, defaultFonts } from '@wds/utils';
import { HeaderTheme } from '../../theme';

const useStyles = createMemoStyles((theme: HeaderTheme) => {
  const { text, background, height, spacing } = theme;
  return {
    navBar: {
      ...defaultFonts(theme),
      position: 'relative',
      backgroundColor: background.main,
      color: text.main,
      width: '100%',
      margin: 0,
      zIndex: 1000,
      height,
    },
    navBarBox: {
      whiteSpace: 'nowrap',
      padding: `0 ${spacing[5]}px`,
    },
  };
});

export default useStyles;
